import { createContext, useContext } from "react";

/** Interface between the tables chooser and the add-in ("host") that mounts it. */
export interface TablesChooserHost {
    /** Called after the chooser persisted the chosen table's settings, with the object it persisted. */
    onTableChosen(settings: Record<string, unknown>): void;
}

export const TablesChooserHostContext = createContext<TablesChooserHost | undefined>(undefined);

/** The host the chooser was mounted in. */
export function useTablesChooserHost(): TablesChooserHost {
    const host: TablesChooserHost | undefined = useContext(TablesChooserHostContext);
    if (!host) {
        throw new Error("The tables chooser renders outside mountReactTablesChooser(host).");
    }
    return host;
}
